import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type { Log } from '@blakeelearning/log'
import type RouterService from '@ember/routing/router-service'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default class extends Route {
  @service log!: Log

  @service router!: RouterService

  queryParams = {
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
    grade: {
      replace: true,
      refreshModel: true,
    },
    tags: {
      replace: true,
    },
  }

  model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    // if its not writing subscription type, redirect to home
    if (subscriptionType !== SubscriptionType.Writing) {
      this.log.error('exciting writing ideas page is only available for writing subscription type')
      void this.router.replaceWith('subscription-type.home')
      return { subscriptionType }
    }
  }
}
